<template>
  <div>
    <div
      class="container-top mt-5"
      :class="{ 'container-medium': lgAndUp || xlAndUp }"
    >
      <div class="row d-md-flex justify-content-between mb-5">
        <div class="col-md-12">
          <div class="text-head h2 font-weight-bold">
            New Convert Life Cycle Settings
          </div>
          <div @click="goBack">
            <span class="s-18 fw-400 cursor-pointer text-black">
              <img src="../../assets/gobacck.png" class="w-12 h-12" alt="" /> Go
              back</span
            >
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div class="row border-radius-8 bg-gray-200 pb-3 pt-3 px-3 mt-5">
            <div class="col-md-12">
              <div class="row">
                <div class="col-md-12">
                  <h4 class="mt-2 text-dak fw-500 mb-2">
                    Add Your New Convert Life Cycle
                  </h4>
                </div>
                <Toast />
                <ConfirmDialog />
              </div>

              <div class="row">
                <div class="col-md-12 py-2">
                  <div class="row d-flex">
                    <div class="col-md-12">
                      <el-input
                        type="text"
                        class="w-100"
                        placeholder="Add Your New Convert Life Cycle"
                        v-model="newConvertTypes"
                        size="large"
                      />
                    </div>
                  </div>
                  <div class="row mt-2 d-flex">
                    <div class="col-md-6 d-flex flex-wrap">
                      <div class="col-md-6">
                        <div>
                          <el-checkbox v-model="isDefault" :binary="true" />
                          <span class="ml-2 mt-2">Mark As default</span>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div>
                          <el-checkbox v-model="createGroup" :binary="true" />
                          <span class="ml-2 mt-2"
                            >Create group
                            <el-tooltip
                              class="box-item"
                              effect="dark"
                              content="This creates a group where members in this lifecycle will be added"
                              placement="top-start"
                            >
                            </el-tooltip>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12 d-flex justify-content-end">
                      <div class="col-md-3">
                        <el-button
                          round
                          size="large"
                          :color="primarycolor"
                          class="font-weight-bold primary-btn w-100 text-white py-4 mt-3"
                          @click="saveNewConvert"
                          >Save</el-button
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div
              class="col-md-12 border-radius-8 mt-4"
              style="border: 1px solid #aaaaaa"
            >
              <div class="row table-header-row py-3">
                <div class="col-md-7">
                  <span class="py-2 pl-3 fw-500 text-dak">Life Cycle</span>
                </div>
              </div>

              <div class="row">
                <div class="col-12 text-center p-5" v-if="loading">
                  <i
                    class="pi pi-spin pi-spinner text-center text-primary"
                    style="font-size: 3rem"
                  ></i>
                </div>
              </div>
              <div
                class="list-group-item list-group row"
                v-for="(newConvert, indx) in newConvertData"
                :key="indx"
                @drop="handleDrop"
              >
                <div class="col-md-12">
                  <div class="row pl-2">
                    <div
                      class="col-md-7 px-0 d-flex justify-content-between align-items-center mb-md-0 mb-5"
                    >
                      <span class="py-2 text-dak fw-500 hidden-header"
                        >Name</span
                      >

                      <span
                        class="py-2 font-weight-bold text-dak text-xs-left mr-md-0 mr-4"
                        >{{ newConvert.name }}</span
                      >
                    </div>

                    <div
                      class="col-md-5 px-0 mb-md-0 mb-2 col-12 d-flex justify-content-end align-items-end"
                    >
                      <div
                        class="row"
                        v-if="vissibleTab !== `tab_${newConvert.index}`"
                      >
                        <div
                          class="col-md-6 col-6 d-flex justify-content-center"
                        >
                          <el-button
                            class="py-1 px-4"
                            style="background-color: #b4f1f4"
                            @click="openClassification(newConvert.index)"
                            size="large"
                            round
                            color="#EBEFF4"
                          >
                            <span
                              style="color: #030303 !important"
                              class="fw-400 s-16"
                              >Edit</span
                            >
                          </el-button>
                        </div>
                        <div
                          class="col-md-6 col-6 d-flex justify-content-start"
                        >
                          <el-button
                            class="py-1 delete-btn text-white"
                            @click="deletePop(newConvert.id)"
                            size="large"
                            round
                          >
                            <span class="s-16 fw-400">Delete</span>
                          </el-button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    class="row bg-gray-200 py-1 border-radius-8 ml-0 mr-1 mt-2"
                    v-if="vissibleTab === `tab_${newConvert.index}`"
                  >
                    <div
                      class="col-md-7 d-flex justify-content-between align-items-center mb-md-0 mb-2"
                    >
                      <label for="" class="d-flex mt-4">
                        <el-input
                          type="text"
                          class="w-100"
                          v-model="newConvert.name"
                        />
                      </label>
                      <label for="" class="d-flex mt-4">
                        <span class="mr-2">Mark As Default</span>
                        <el-checkbox
                          v-model="newConvert.isDefault"
                          :binary="true"
                        />
                      </label>
                    </div>
                    <div
                      class="col-md-5 d-flex justify-content-end align-items-center mt-0"
                    >
                      <div class="row">
                        <div
                          class="col-md-6 col-6 d-flex justify-content-start"
                        >
                          <el-button
                            class="secondary-button px-3"
                            @click="discard"
                            color="#F6F6F6"
                            round
                          >
                            Discard
                          </el-button>
                        </div>
                        <div
                          class="col-md-6 col-6 d-flex justify-content-start"
                        >
                          <el-button
                            round
                            class="text-white py-1 px-4 ml-md-0 ml-5"
                            color="#0B55D4"
                            @keyup.enter.prevent="
                              updatenewConvert(newConvert, newConvert.index)
                            "
                            @click="
                              updatenewConvert(newConvert, newConvert.index)
                            "
                            >Save</el-button
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, inject } from "vue";
import axios from "@/gateway/backendapi";
import { ElNotification, ElMessageBox } from "element-plus";
import finish from "../../services/progressbar/progress";
import router from "../../router";

import deviceBreakpoint from "../../mixins/deviceBreakpoint";

// Component name for debugging (Vue 3.3+)
// defineOptions({
//   name: "NewConvertLifecycle",
// });

// Inject dependencies
const primarycolor = inject("primarycolor");

const { mdAndUp, lgAndUp, xlAndUp, xsOnly } = deviceBreakpoint();

// Reactive data
const newConvertData = ref([]);
const vissibleTab = ref("");
const newConvertName = ref("");
const newConvertOrder = ref("");
const newConvertTypes = ref("");
const isDefault = ref(false);
const loading = ref(false);
const enabled = ref(true);
const dragging = ref(false);
const createGroup = ref(false);

// Methods
const goBack = () => {
  router.go(-1);
};

const getnewConvertCyles = async () => {
  try {
    loading.value = true;
    const { data } = await axios.get("/newconvertCycle");
    newConvertData.value = data.returnObject
      .map((item, index) => {
        item.index = index;
        return item;
      })
      .sort((a, b) => a.order - b.order);
    console.log(data);
    loading.value = false;
  } catch (error) {
    loading.value = false;
    console.log(error);
  }
};

const handleDrop = async () => {
  try {
    setTimeout(async () => {
      const ordered = newConvertData.value.map((i, j) => {
        return { id: i.id, order: j + 1, name: i.name };
      });
      loading.value = true;
      const response = await axios.put(
        "/newconvertlifecycle/orderstages",
        ordered
      );
      console.log(response);
      loading.value = false;
      ElNotification({
        type: "success",
        message: "New Guest Life Cycle Order Updated Successfully",
        duration: 5000,
      });
      console.log(ordered, "ORDERED");
    }, 1000);
  } catch (error) {
    console.log(error);
  }
};

const saveNewConvert = async () => {
  try {
    let createnewConvert = {
      name: newConvertTypes.value,
      isDefault: isDefault.value,
      createAsAGroup: createGroup.value,
    };
    await axios.post("/newconvertCycle/create", createnewConvert);
    getnewConvertCyles();
    newConvertTypes.value = "";
    isDefault.value = false;
    createGroup.value = false;
    ElNotification({
      type: "success",
      message: "New Guest Life Cycle Save Successfully",
      duration: 5000,
    });
  } catch (error) {
    finish();
    console.log(error);
  }
};

const updatenewConvert = async (item) => {
  try {
    console.log(item, "item");
    await axios.put(`/newconvertlifecycle/${item.id}/edit`, {
      ...item,
      name: item.name,
      isDefault: item.isDefault,
    });
    discard();
    ElNotification({
      type: "success",
      message: "New Guest Life Cycle Updated Successfully",
      duration: 5000,
    });
  } catch (error) {
    finish();
    console.log(error);
  }
};

const deletenewConvert = async (id) => {
  console.log(id);
  try {
    let data = await axios.delete(`/newconvertlifecycle/${id}/delete`);
    console.log(data);
    newConvertData.value = newConvertData.value.filter((i) => i.id !== id);
    ElNotification({
      type: "success",
      message: "Delete Successfully",
      duration: 5000,
    });
  } catch (error) {
    finish();
    console.log(error);
  }
};

const deletePop = (id) => {
  ElMessageBox.confirm("Are you sure you want to Delete?", "Confirm delete", {
    confirmButtonText: "OK",
    cancelButtonText: "Cancel",
    type: "error",
  })
    .then(() => {
      deletenewConvert(id);
    })
    .catch(() => {
      ElNotification({
        type: "info",
        message: "Delete canceled",
        duration: 5000,
      });
    });
};

const openClassification = (index) => {
  vissibleTab.value = `tab_${index}`;
  newConvertName.value = newConvertData.value[index].name;
};

const discard = () => {
  vissibleTab.value = "";
};

const checkMove = (e) => {
  window.console.log("Future index: " + e.draggedContext.futureIndex);
};

// Lifecycle
onMounted(() => {
  getnewConvertCyles();
});
</script>

<style scoped>
.button {
  margin-top: 35px;
}
.flip-list-move {
  transition: transform 0.5s;
}
.no-move {
  transition: transform 0s;
}
.ghost {
  opacity: 0.5;
  background: #cbd1d3;
}
.list-group {
  min-height: 20px;
}
.list-group-item i {
  cursor: pointer;
}
input::placeholder {
  text-align: center;
}
.delete-btn {
  background: #ff3737 !important;
}
.delete-btn:hover {
  background-color: red !important;
  color: white !important;
}
.table-header-row {
  background: #f6f6f6;
  border-radius: 8px;
}

.hidden-header {
  display: none;
}

.grey-background {
  background: #dde2e6;
}

.save-btn {
  background: #50ab00;
}
.first {
  font: var(--unnamed-font-style-normal) normal 800 34px/46px
    var(--unnamed-font-family-nunito-sans);
  letter-spacing: var(--unnamed-character-spacing-0);
  text-align: left;
  font: normal normal 800 34px/46px Nunito Sans;
  letter-spacing: 0px;
  color: #02172e;
  opacity: 1;
}
.first1 {
  font: var(--unnamed-font-style-normal) normal var(--unnamed-font-weight-bold)
    24px/32px var(--unnamed-font-family-nunito-sans);
  letter-spacing: var(--unnamed-character-spacing-0);
  text-align: left;
  font: normal normal bold 24px/32px Nunito Sans;
  letter-spacing: 0px;
  color: #02172e;
  opacity: 1;
}

@media screen and (max-width: 767px) {
  .hidden-header1 {
    display: none !important;
  }
  .hidden-header {
    display: inline-block;
    font-weight: bold;
  }

  .table-header-row {
    display: none;
  }
}
@media screen and (max-width: 390px) {
  .first {
    font: var(--unnamed-font-style-normal) normal 500 20px/25px
      var(--unnamed-font-family-nunito-sans);
    letter-spacing: var(--unnamed-character-spacing-0);
    text-align: left;
    font: normal normal 800 20px/25px Nunito Sans;
    letter-spacing: 0px;
    color: #02172e;
    opacity: 1;
  }
  .first1 {
    font: var(--unnamed-font-style-normal) normal
      var(--unnamed-font-weight-bold) 24px/32px
      var(--unnamed-font-family-nunito-sans);
    letter-spacing: var(--unnamed-character-spacing-0);
    text-align: left;
    font: normal normal bold 15px/16px Nunito Sans;
    letter-spacing: 0px;
    color: #02172e;
    opacity: 1;
  }
}
.help {
  border: 1px solid #6a6a6a;
  width: 14px;
  height: 14px;
  display: inline-block;
  padding: 6px 0px 6px 3px;
  border-radius: 50%;
  color: #6a6a6a;
  cursor: pointer;
}
</style>
